import { calculateTotalCredit } from "jsFunctions/helperFunctions";

export const isValidateCredit = (multipleCredit,editData) => {
    if (multipleCredit && multipleCredit.length > 0) {

      for (const item of multipleCredit) {
        let availableAmt = 0;
        if(item?.crId && item?.crId?._id){
           
            const remainingAmount = parseFloat(item?.crId?.amt) - (parseFloat(item?.crId?.usAmt || 0) + parseFloat(item?.crId?.resAmt || 0));
            const existCreditData = editData?.crApl?.list;
            const existCreditItem = existCreditData?.find((e)=>e?.crId?._id === item?.crId?._id)
            const totalAvailableCredit = parseFloat(remainingAmount || 0) + parseFloat(existCreditItem?.usAmt || 0)
            availableAmt = parseFloat(totalAvailableCredit) - parseFloat(item?.usAmt || 0)
      
          }
          else{
           
            const remainingAmount = parseFloat(item?.amt || 0) - (parseFloat(item?.usAmt || 0) + parseFloat(item?.resAmt || 0));
            const totalAvailableCredit = parseFloat(remainingAmount || 0)
            availableAmt = parseFloat(totalAvailableCredit)
          }
        if(availableAmt && availableAmt > 0){
            return false
        }
      }
    }

    return true;
  };


export const creditAmountMismatch = (multipleCredit,editData)=>{
    const existingCredit = editData?.crApl?.list;
    const existCreditItems = existingCredit?.map((item)=>{
      if(item?.crId){
        return {
          ...item?.crId,
          usAmt:item?.usAmt
        };
      }
      else{
        return item;
      }
    })
  
    const creditItems = multipleCredit?.map((item)=>{
      if(item?.crId){
        return {
          ...item?.crId,
          usAmt:item?.usAmt
        };
      }
      else{
        return item;
      }
    })
  
    const sumOfExist = calculateTotalCredit(existCreditItems);
    const sumOfMultipleCredit = calculateTotalCredit(creditItems);
  
    return parseFloat(sumOfExist || 0) !== parseFloat(sumOfMultipleCredit);
}